/*=========================================================================================
  File Name: moduleDevice.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleDeviceState.js'
import mutations from './moduleDeviceMutations.js'
import actions from './moduleDeviceActions.js'
import getters from './moduleDeviceGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

